import { Route, Settings } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { NavLink } from 'react-router-dom';

const TopMenu = () => {
  return (
    <>
      <Tooltip title="Planificación">
        <IconButton size="large" component={NavLink} to="/">
          <Route />
        </IconButton>
      </Tooltip>
      <Tooltip title="Mapas">
        <IconButton size="large" component={NavLink} to="/settings">
          <Settings />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default TopMenu;
